import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CoreService } from '../core/core.service';
import { EkubService } from './ekub.service';
import { Main } from '../core/main.service';

@Component({
  selector: 'cp-categories',
  templateUrl: './categories.component.html',
})

export class CategoriesComponent {

  category: any;
  option: any;
  file: any;
  isLoading: any;
  id: string;
  categoryForm!: FormGroup;
  config: any;
  operation: string;

  filter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  categories: any[];
  intervals: any[];

  constructor(private route: ActivatedRoute,
    private formBuilder: FormBuilder, private mainService: Main, private coreService: CoreService, private api: EkubService, private router: Router,
    @Inject(Restangular) public Restangular) {
    this.category = {
      'title': '',
      'amount': 0,
      'interval': 'weekly',
      'remark': ''
    };
    this.intervals = [{ value: 'daily' }, { value: 'weekly' }, { value: 'monthly' }];
    this.intervals = ['daily', 'weekly', 'monthly'];
    this.isLoading = false;
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
      //this.getCategory();
    }
    this.operation = 'add';
    this.option = {
      width: '200',
      tags: true
    };
  }

  get title() { return this.categoryForm.get('title'); }
  get amount() { return this.categoryForm.get('amount'); }
  get interval() { return this.categoryForm.get('interval'); }
  get remark() { return this.categoryForm.get('remark'); }

  ngOnInit() {
    this.createForm();
    this.getCategories()
  }

  getCategories() {
    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getCategories(this.currentPage, this.filter).subscribe((resp: any) => {
      debugger;
      this.categories = resp.data;
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      debugger;
      //this.coreService.addToast('Error', err.statusText);
    });
  }

  private createForm() {

    this.categoryForm = this.formBuilder.group({
      title: ['', [Validators.required,]],
      amount: ['', [Validators.required]],
      interval: ['', [Validators.required]],
      remark: [''],
    });
  }

  getCategory() {
    this.api.getCategory(this.id).subscribe((res: any) => {
      debugger;
      this.category = res.data;
      this.categoryForm.setValue(res.data);
    });
  }


  fileChange(event): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  addCategory() {
    debugger;
    this.isLoading = !this.isLoading;
    var id = this.category.id;
    this.category = this.categoryForm.value;
    this.api.createCategory(this.category, id).subscribe((res: any) => {
      debugger;
      this.isLoading = !this.isLoading;
      this.categoryForm.reset();
      this.getCategories();
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Category successfully updated! ' : 'Category  successfully added!', type: 'dark' });
    }, (err) => {
      debugger;
      err = err;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Error', body: (err.data.detail) ? err.data.detail : (this.id) ? 'Could not update category!' : 'Could not add category!', type: 'danger' });

    });
  }

  reset() {
    debugger;
    this.operation = 'add';
    this.categoryForm.reset();
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getCategories();
  }

  editCategory(category: any) {
    debugger;
    this.category = category;
    this.categoryForm.get('title').setValue(category.title);
    this.categoryForm.get('amount').setValue(category.amount);
    this.categoryForm.get('interval').setValue(category.interval);
    this.categoryForm.get('remark').setValue(category.remark);
    this.operation = 'update';
  }

}
